export const extractNumberFromFormattedString = (formattedString: string | number): number => {
    if (typeof formattedString === 'number') {
        return formattedString;
    }
    const number = formattedString.replace(/[^0-9.]/g, '');
    return isNaN(parseFloat(number)) ? 0 : parseFloat(number);
};